import { CustomerDTO } from '@beable/roster-backend-client-v1';
import { Card, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { getStyles } from '../../theme/styles';

interface ProvisionSelectProps {
  customer: CustomerDTO | undefined;
}

export default function CustomerCard(props: ProvisionSelectProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  let customer = new CustomerDTO();

  if (props.customer) {
    customer = props.customer;
  }

  return (
    <Card sx={styles.customerCard} variant='outlined'>
      <Typography variant='h6' component='h6' sx={styles.customerCard_caption}>
        {customer.name}
      </Typography>
      <Typography variant='body1' component='p' sx={styles.customerCard_content}>
        {customer.id} <br />
        {customer.locationCode && customer.locationCode.split('-').pop()} <br />
        {customer.url} <br />
        {customer.totalSchools >= 0 && 'Total Schools: ' + customer.totalSchools}<br />
        {customer.studentEnrollment >= 0 && 'Student Enrollment: ' + customer.studentEnrollment}<br />
      </Typography>
    </Card>
  );
}
